// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../static/fonts/NotoSans/woff2/NotoSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../static/fonts/NotoSans/woff/NotoSans-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../static/fonts/NotoSans/ttf/NotoSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../static/fonts/NotoSans/woff2/NotoSans-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../static/fonts/NotoSans/woff/NotoSans-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../static/fonts/NotoSans/ttf/NotoSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../static/fonts/NotoSans/woff2/NotoSans-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../static/fonts/NotoSans/woff/NotoSans-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../static/fonts/NotoSans/ttf/NotoSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
   font-family: 'NotoSans-Regular';
   src:
      url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
      url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
      url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
   font-weight: normal;
   font-style: normal;
   font-display: swap;
}

@font-face {
   font-family: 'NotoSans-Bold';
   src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2'),
      url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff'),
      url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
   font-weight: normal;
   font-style: normal;
   font-display: swap;
}

@font-face {
   font-family: 'NotoSans-SemiBold';
   src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
      url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff'),
      url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
   font-weight: normal;
   font-style: normal;
   font-display: swap;
}

:root {
   --font-main: 'NotoSans-Regular';
   --font-bold: 'NotoSans-Bold';
   --font-semi-bold: 'NotoSans-SemiBold';

   /* These colors brought to you by the mysterious Janette? It appears on the
    desktop style sheet. Legend has it that at some point, a graphic designer was hired to 
    create mockups for the web and potentially the desktop. 
    There is tension about this decision so no one knows 
    if we should indeed be using the mockups as a reference. 
    But, according to Sean, these colors were approved by PM or someone decided they 
    "made things look nice." 
    https://discordapp.com/channels/400029880110022666/775428762803503124/1033103249588371546
    Marketing does not know about these colors as of 10/2022.*/

   --darkest: #050505;
   --dark-mine-shaft: #191919;
   --less-dark-mine-shaft: #1d1d1d;
     /* from marketing 10/17/22, numbers 20-80 refer to percentage of tint
        These colors do not completely match desktop and I'm not sure why. It's not just the RGB
        values being different from HEX codes. For example, there are 4 orange hues on
        desktop and none of them match the RGB value for Orange Blaze from marketing.
    */
   --true-white: white;

   --mine-shaft: #222222;
   --mine-shaft-90: #333333;
   --mine-shaft-80: #4F4C4D;
   --mine-shaft-60: #717171;
   --mine-shaft-40: #9E9E9E;
   --mine-shaft-20: #CDCDCD;

   --dust-gray: #898C8E;
   --dust-gray-80: #ABAEAF;
   --dust-gray-60: #B6B8B9;
   --dust-gray-40: #CECFD0;
   --dust-gray-20: #E6E6E6;

   --alto-gray: #C4C4C4;
   --alto-gray-80: #E0DFDE;
   --alto-gray-60: #E7E7E6;
   --alto-gray-40: #EFEFEE;
   --alto-gray-20: #F9F9F9;

   --blue-stone: #005D63;
   --blue-stone-80: #037C7F;
   --blue-stone-60: #5A9C9D;
   --blue-stone-40: #92BCBD;
   --blue-stone-20: #C8DDDD;

   --deep-teal: #008996;
   --deep-teal-80: #00A1AA;
   --deep-teal-60: #3DB9BE;
   --deep-teal-40: #8AD0D3;
   --deep-teal-20: #C6E7E8;

   --jade-glow: #00C08B;
   --jade-glow-80: #00CEA1;
   --jade-glow-60: #6ADBB8;
   --jade-glow-40: #A1E8CF;
   --jade-glow-20: #DBF2EC;

   --supernova-gold: #FFD100;
   --supernova-gold-80: #FFD934;
   --supernova-gold-60: #FFE270;
   --supernova-gold-40: #FFEBA1;
   --supernova-gold-20: #FFF4D0;

   --orange-blaze: #FF6B00;
   --orange-blaze-80: #FF8C1C;
   --orange-blaze-60: #FFA95D;
   --orange-blaze-40: #FFC692;
   --orange-blaze-20: #FFE2C7;

   --red-fire: #E04403;
   --red-fire-80: #EE6E3D;
   --red-fire-60: #F8946B;
   --red-fire-40: #FFB79A;
   --red-fire-20: #FFDBCB;

   /*Colors for code editor*/
   --light-green: #008f00;
   --dark-green: #008f00;

   /* Global Semantic Coloring */
   --widget-disabled-opacity: 40%;
   --transparent: transparent;
   --success: var(--jade-glow);
   --warning: var(--supernova-gold);
   --error: var(--red-fire);
   --required: var(--red-fire);

   /* Global Semantic Padding & Margins */
   --padding: 10px;
   --padding-lg: calc(var(--padding) * 2);
   --padding-sm: calc(var(--padding) / 2);
   --margin: 5px;

   /* Global Semantic Border Radius */
   --border-radius: 10px;

   /* Global Semantic Fontsize */
   --font-size: 16px;

   /* Global Height */
   --input-height: 40px;

   /* Global Width */
   --input-width: 300px;

   /* Header Menu Vars (Theme-less, might change) */
   --header-bg: var(--mine-shaft-80);
   --header-drop-down-bg: var(--mine-shaft-40);
   --header-drop-down-hover: var(--darkest);

   --fa-width: auto
}

/* Semantic theme Variables */
[data-theme="Light"] {
   --text: var(--mine-shaft);
   /* According to Bri this is only used for text in disabled text boxes, not buttons or links etc - those will be set to --widget-disabled-opacity */
   --text-disabled: var(--dust-gray);
   --window-bg: var(--alto-gray-40);
   /* if we do want to differentiate a child window from the parent we use the ecl::SubWindowBg - Brianna */
   --sub-window-bg: var(--true-white);
   /* popupBG is for popups, which is everything that isnt a normal window, this includes modals, tooltips, context menus - Brianna */
   --popup-bg: var(--true-white);

   /* frameBg is the background color of widgets, like the inside of the square of a tex box - Brianna */
   --frame-bg: var(--true-white);
   --frame-bg-hovered: var(--alto-gray);
   --border: 1px solid var(--alto-gray-80);

   /* Buttons */
   --button-primary: var(--mine-shaft-60);
   --button-primary-hovered: var(--mine-shaft-40);
   --button-primary-text: var(--true-white);
   --button-primary-clicked: var(--deep-teal-20);

   /* Tabs */
   /* these are for things like tabs on documents and links in the nav bar 
    maybe drop down options that you'd hover and select? Didn't want to call it 'option' bc of HTML option
    */
   --tab-unfocused-active: var(--dust-gray-40);
   --tab-hovered: var(--jade-glow-20);

   --required-text-color: var(--red-fire);

   /* Extra web semantic colors */
   --link-text: var(--deep-teal);
   --link-text-hovered: var(--deep-teal-80);
   /* Needed a different color scheme for the right-side info panel */
   --sidebar-bg: var(--true-white);
   --outline-focus-visible: 1px solid var(--jade-glow);
   /*Table Theming, alternate rows */
   --table-alt-row: var(--sub-window-bg);
   --table-body-border: var(--dust-gray-20);
   --table-row-hover: var(--blue-stone-20);

   /*I needed another gray color*/
   --gray-accent: var(--dust-gray-20);

   /*Need colors for code editor*/
   --t-comment: var(--light-green);
   --t-variable-name: #ef5312;
   --t-keyword: #00b785;
   --t-function: #d5af00;
}

[data-theme="Dark"] {
   --text: var(--true-white);
   /* According to Bri this is only used for text in disabled text boxes, not buttons or links etc - those will be set to --widget-disabled-opacity */
   --text-disabled: var(--dust-gray);
   --window-bg: var(--mine-shaft);
   /* if we do want to differentiate a child window from the parent we use the ecl::SubWindowBg - Brianna */
   --sub-window-bg: var(--dark-mine-shaft);
   /* popupBG is for popups, which is everything that isnt a normal window, this includes modals, tooltips, context menus - Brianna */
   --popup-bg: var(--darkest);
   /* frameBg is the background color of widgets, like the inside of the square of a tex box - Brianna */
   --frame-bg: var(--mine-shaft);
   --frame-bg-hovered: var(--mine-shaft-80);
   --border: 1px solid var(--dust-gray);

   /* Buttons */
   --button-primary: var(--mine-shaft-60);
   --button-primary-hovered: var(--mine-shaft-80);
   --button-primary-text: var(--true-white);
   --button-primary-clicked: var(--deep-teal-80);

   /* Tabs */
   /* these are for things like tabs on documents and links in the nav bar 
    maybe drop down options that you'd hover and select? Didn't want to call it 'option' bc of HTML option
    */
   --tab-unfocused-active: var(--dust-gray-80);
   --tab-hovered: var(--jade-glow-80);

   --required-text-color: var(--red-fire);

   /* Extra web semantic colors */
   --link-text: var(--deep-teal-60);
   --link-text-hovered: var(--deep-teal-40);
   /* Needed a different color scheme for the right-side info panel */
   --sidebar-bg: var(--mine-shaft);
   --outline-focus-visible: 1px solid var(--jade-glow);

   /*Table Theming, alternate rows */
   --table-alt-row: var(--sub-window-bg);
   --table-body-border: #171717;
   --table-row-hover: var(--blue-stone);
   /*I needed another gray color*/
   --gray-accent: var(--less-dark-mine-shaft);

   /*Need colors for code editor*/
   --t-comment: var(--dark-green);
   --t-variable-name: var(--red-fire);
   --t-keyword: var(--jade-glow);
   --t-function: var(--warning);
}



/* Global default element styles */
* {
   box-sizing: border-box;
   font-family: var(--font-main), sans-serif;

}

/* Chrome/safari scrollbar styling */
*::-webkit-scrollbar {
   width: 5px;
   height: 5px;
   background-color: var(--frame-bg);
}

*::-webkit-scrollbar-thumb {
   background-color: var(--text);
   border-radius: var(--border-radius);
}

html {
   font-size: var(--font-size);
   letter-spacing: 1px;
}

body {
   margin: 0;
}

#thematic-div {
   background-color: var(--window-bg);
   color: var(--text);
}

.universal-height-width-container {
   width: 100vw;
   width: 100dvw;
   height: 100vh;
   height: 100dvh;
   /* these numbers need to come from PM */
   min-height: 320px;
   min-width: 320px;
}

nav {
   background-color: var(--sub-window-bg);
}

/* Many birds, one stone rules */
div,
header,
main,
.main-router-main {
   background-color: inherit;
   color: inherit;
}

.main-router-main {
   height: calc(100% - 60px);
   width: 100%;
}

input,
textarea,
select {
   color: var(--text);
   background-color: var(--frame-bg);
   border: var(--border);
   font: inherit;
}

input:focus-visible,
textarea:focus-visible,
select:focus-visible,
button:focus-visible {
   outline: var(--outline-focus-visible);
}

input:invalid:not(:placeholder-shown):not([type="checkbox"]):not([type="radio"]) {
   outline: 2px solid var(--required);
}

input,
select,
.global-menu-select,
button {
   height: var(--input-height);
}

input[type="file"] {
   padding: 7px;
}

input[type='range'] {
   -webkit-appearance: none;
   appearance: none;
   width: 100%;
   border-radius: 13px;
   height: 12px;
   /* border: 1px solid var(--jade-glow-40);
   background-color: var(--jade-glow-20);  */
}

input:autofill {
   background-color: var(--frame-bg);
   color: var(--text)
}

input:-webkit-autofill {
   -webkit-box-shadow:0 0 0 50px var(--frame-bg) inset; /* Change the color to your own background color */
   -webkit-text-fill-color: var(--text);
}

input:-webkit-autofill:focus {
   -webkit-box-shadow: 0 0 0 50px var(--frame-bg) inset;/*your box-shadow*/
   -webkit-text-fill-color: var(--text);
} 

input[type='range']::-webkit-slider-thumb {
   -webkit-appearance: none;
   background-color: var(--jade-glow);
   border: 1px solid var(--jade-glow-80);
   width: 32px;
   height: 32px;
   border-radius: 16px;
   cursor: pointer;
}

input[type='range']::-moz-range-track {
   width: 100%;
   border-radius: 13px;
   height: 12px;
   /* border: 1px solid var(--jade-glow-40);
   background-color: var(--jade-glow-20);  */
}

input[type='range']::-moz-range-thumb {
   background-color: var(--jade-glow);
   border: 1px solid var(--jade-glow-60);
   width: 32px;
   height: 32px;
   border-radius: 16px;
   cursor: pointer;
}

@media (min-width: 769px) and (orientation: portrait),
(min-height: 769px) and (orientation: landscape) {

   input,
   select,
   .global-menu-select,
   button {
      height: 32px;
   }

   input[type="file"] {
      padding: 3px;
   }

   input[type='range'] {
      -webkit-appearance: none;
      appearance: none;
      width: 100%;
      border-radius: 8px;
      height: 7px;
      /* border: 1px solid var(--jade-glow-40);
      background-color: var(--jade-glow-20);  */
   }

   input[type='range']::-webkit-slider-thumb {
      width: 20px;
      height: 20px;
      border-radius: 10px;
   }

   input[type='range']::-moz-range-track {
      width: 100%;
      border-radius: 8px;
      height: 7px;
      /* border: 1px solid var(--jade-glow-40);
      background-color: var(--jade-glow-20);  */
   }

   input[type='range']::-moz-range-thumb {
      width: 20px;
      height: 20px;
      border-radius: 10px;
   }
}

input,
select,
button {
   border-radius: var(--border-radius);
}

input,
textarea,
.global-menu-select,
select {
   width: 100%;
   /* This min-width was causing the inputs inside of login in to blow up*/
   /* min-width: var(--input-width); */
}

input,
textarea,
select {
   padding: var(--padding-sm);
}


/* Things that can be disabled */
fieldset:disabled,
input:disabled,
optgroup:disabled,
option:disabled,
select:disabled,
textarea:disabled {
   color: var(--text-disabled)
}

/* Element-specific rules */
label {
   font-weight: bold;
   padding: var(--padding-sm);
   display: block
}

button {
   border: none;
   text-decoration: none;
   background: var(--button-primary);
   color: var(--button-primary-text);
   cursor: pointer;
   text-align: center;
   /* overflow: hidden;
   text-overflow: ellipsis; */
   white-space: nowrap;
   transition: background 0.2s;
   padding: var(--padding-sm);
   font-size: 1rem;
   margin: var(--margin);
   min-width: 40px;
}

button:hover:not(:disabled) {
   background-color: var(--button-primary-hovered);
}

button:disabled {
   opacity: var(--widget-disabled-opacity);
   cursor: auto;
}

button>img,
summary>img,
imput>img,
input>.themed-svg-container,
button>.themed-svg-container,
summary>.themed-svg-container,
.select-custom-trigger>.themed-svg-container {
   height: 1em;
   width: 1em;
}


@media (min-width: 769px) and (orientation: portrait),
(min-height: 769px) and (orientation: landscape) {
   button {
      min-width: 32px;
   }
}

button:has(img),
button:has(.themed-svg-container:only-child) {
   background-color: transparent;
   display: flex;
   align-items: center;
   justify-content: center;
}

button>p {
   padding: var(--padding);
}


button.secondary-button {
   background-color: var(--window-bg);
   border: 1px solid var(--deep-teal);
   color: var(--text);
}

button.secondary-button:hover {
   background-color: var(--sub-window-bg);
}

/* Link */
a {
   color: var(--link-text);
   cursor: pointer;
   text-decoration: none;
   padding: var(--padding-sm);
}

a:hover {
   text-decoration: underline;
   color: var(--link-text-hovered);
}

p a {
   /* No link padding when inside a paragraph element*/
   padding: none;
}

/* Lists */
ol {
   padding: var(--padding-lg);
}

ul {
   padding-left: var(--padding);
}

/* line-height is a more consistant spacer than using padding/margin on li items */
li {
   line-height: 1.75rem;
   list-style-position: inside;
}

/* details and summary are related to list elements style wise*/
details {
   display: flex;
   flex-direction: column;
}

details>details {
   margin-left: var(--margin);
}

/* That said this is basically button without flex styling (due to historic list css reasons) */
summary {
   border: none;
   text-decoration: none;
   background: var(--button-primary);
   color: var(--button-primary-text);
   cursor: pointer;
   text-align: left;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   transition: background 0.2s;
   padding: var(--padding-sm);
   border-radius: var(--border-radius);
   margin: calc(var(--margin) / 2);
   height: unset;
}

summary:hover {
   background-color: var(--button-primary-hovered);
}

/* Headers */
h1,
h2,
h3,
h4,
h5,
h6 {
   margin: 0;
   padding: var(--padding);
}

h1 {
   font-size: 2em;
}

/* images */
img {
   /*
    This removes extra spacing below image margin due to img's inherent inline block display.
    Essentially, images are treated like text and use text alignment properties, which pads outside the margin
    a number of pixels based on the element's font size.  This is so that lowercase letters like 'g' and 'y' don't
    hang below an element, even when its padding and margins are set to 0.
    */
   vertical-align: bottom;
}

/* paragraphs */
p {
   margin: 0;
   padding: var(--padding);
}

/* Input */
input[type="radio"],
input[type="checkbox"] {
   width: 10px;
   min-width: unset;
}

/*Make number pickers slightly bigger on chromium*/
input[type="number"]::-webkit-inner-spin-button {
   height: 10px;
   padding: 10px 0px;
   margin-right: 2px;
   cursor: pointer;
}

/*Select*/
select {
   cursor: pointer;
}

select:hover {
   background-color: var(--frame-bg-hovered);
}

input:hover {
   cursor: pointer;
   background-color: var(--frame-bg-hovered);
}

button:active {
   background-color: var(--button-primary-clicked) !important;
}

select:focus {
   outline: none;
}

select::-ms-expand {
   display: none;
}

option {
   color: var(--text);
   width: 20em;
   background-color: var(--popup-bg);
}

textarea {
   border-radius: var(--border-radius);
   padding: var(--padding);
   vertical-align: bottom;
   margin: unset;
}

pre {
   border: var(--border);
   padding: var(--padding);
   background: var(--sub-window-bg);
   overflow: auto;
}

code {
   font-family: monospace;
}

/* Table Styling */
table {
   border-collapse: collapse;
   /* This supposedly lets the table render faster - like the top rows first -- needs more research*/
   table-layout: fixed;
   /* required for resizing, so size using parent container if needed */
   width: 100%;
   position: relative;
   background-color: var(--window-bg);
}

tr:nth-child(odd) {
   background-color: var(--table-alt-row);
}

tr:hover {
   background-color: var(--tab-hovered);
}

/* table heading stuff */
thead tr {
   position: sticky;
   top: 0;
   border-bottom: var(--border);
   z-index: 3;
}

th {
   font-size: 1.2rem;
   background-color: var(--sub-window-bg);
   padding: var(--padding-sm);
   white-space: nowrap;
   text-overflow: ellipsis;
   overflow: hidden;
   text-align: left;
}

/* table item stuff */
td {
   white-space: nowrap;
   text-overflow: ellipsis;
   overflow: hidden;
   padding: var(--padding-sm);
}

.required-input {
   color: var(--required-text-color)
}`, "",{"version":3,"sources":["webpack://./src/GlobalStyleSheet.css"],"names":[],"mappings":"AAAA;GACG,+BAA+B;GAC/B;;;gEAG8E;GAC9E,mBAAmB;GACnB,kBAAkB;GAClB,kBAAkB;AACrB;;AAEA;GACG,4BAA4B;GAC5B;;gEAE2E;GAC3E,mBAAmB;GACnB,kBAAkB;GAClB,kBAAkB;AACrB;;AAEA;GACG,gCAAgC;GAChC;;gEAE+E;GAC/E,mBAAmB;GACnB,kBAAkB;GAClB,kBAAkB;AACrB;;AAEA;GACG,+BAA+B;GAC/B,4BAA4B;GAC5B,qCAAqC;;GAErC;;;;;;;;8DAQ2D;;GAE3D,kBAAkB;GAClB,0BAA0B;GAC1B,+BAA+B;KAC7B;;;;KAIA;GACF,mBAAmB;;GAEnB,qBAAqB;GACrB,wBAAwB;GACxB,wBAAwB;GACxB,wBAAwB;GACxB,wBAAwB;GACxB,wBAAwB;;GAExB,oBAAoB;GACpB,uBAAuB;GACvB,uBAAuB;GACvB,uBAAuB;GACvB,uBAAuB;;GAEvB,oBAAoB;GACpB,uBAAuB;GACvB,uBAAuB;GACvB,uBAAuB;GACvB,uBAAuB;;GAEvB,qBAAqB;GACrB,wBAAwB;GACxB,wBAAwB;GACxB,wBAAwB;GACxB,wBAAwB;;GAExB,oBAAoB;GACpB,uBAAuB;GACvB,uBAAuB;GACvB,uBAAuB;GACvB,uBAAuB;;GAEvB,oBAAoB;GACpB,uBAAuB;GACvB,uBAAuB;GACvB,uBAAuB;GACvB,uBAAuB;;GAEvB,yBAAyB;GACzB,4BAA4B;GAC5B,4BAA4B;GAC5B,4BAA4B;GAC5B,4BAA4B;;GAE5B,uBAAuB;GACvB,0BAA0B;GAC1B,0BAA0B;GAC1B,0BAA0B;GAC1B,0BAA0B;;GAE1B,mBAAmB;GACnB,sBAAsB;GACtB,sBAAsB;GACtB,sBAAsB;GACtB,sBAAsB;;GAEtB,yBAAyB;GACzB,sBAAsB;GACtB,qBAAqB;;GAErB,6BAA6B;GAC7B,8BAA8B;GAC9B,0BAA0B;GAC1B,2BAA2B;GAC3B,gCAAgC;GAChC,wBAAwB;GACxB,2BAA2B;;GAE3B,sCAAsC;GACtC,eAAe;GACf,sCAAsC;GACtC,sCAAsC;GACtC,aAAa;;GAEb,kCAAkC;GAClC,qBAAqB;;GAErB,6BAA6B;GAC7B,iBAAiB;;GAEjB,kBAAkB;GAClB,oBAAoB;;GAEpB,iBAAiB;GACjB,oBAAoB;;GAEpB,gDAAgD;GAChD,iCAAiC;GACjC,2CAA2C;GAC3C,wCAAwC;;GAExC;AACH;;AAEA,6BAA6B;AAC7B;GACG,yBAAyB;GACzB,kJAAkJ;GAClJ,iCAAiC;GACjC,gCAAgC;GAChC,wGAAwG;GACxG,kCAAkC;GAClC,kIAAkI;GAClI,6BAA6B;;GAE7B,qGAAqG;GACrG,6BAA6B;GAC7B,oCAAoC;GACpC,uCAAuC;;GAEvC,YAAY;GACZ,sCAAsC;GACtC,8CAA8C;GAC9C,wCAAwC;GACxC,6CAA6C;;GAE7C,SAAS;GACT;;KAEE;GACF,2CAA2C;GAC3C,kCAAkC;;GAElC,sCAAsC;;GAEtC,8BAA8B;GAC9B,6BAA6B;GAC7B,wCAAwC;GACxC,kEAAkE;GAClE,+BAA+B;GAC/B,mDAAmD;GACnD,iCAAiC;GACjC,qCAAqC;GACrC,wCAAwC;GACxC,uCAAuC;;GAEvC,8BAA8B;GAC9B,kCAAkC;;GAElC,8BAA8B;GAC9B,+BAA+B;GAC/B,0BAA0B;GAC1B,oBAAoB;GACpB,qBAAqB;AACxB;;AAEA;GACG,yBAAyB;GACzB,kJAAkJ;GAClJ,iCAAiC;GACjC,8BAA8B;GAC9B,wGAAwG;GACxG,uCAAuC;GACvC,kIAAkI;GAClI,0BAA0B;GAC1B,qGAAqG;GACrG,6BAA6B;GAC7B,wCAAwC;GACxC,oCAAoC;;GAEpC,YAAY;GACZ,sCAAsC;GACtC,8CAA8C;GAC9C,wCAAwC;GACxC,6CAA6C;;GAE7C,SAAS;GACT;;KAEE;GACF,2CAA2C;GAC3C,kCAAkC;;GAElC,sCAAsC;;GAEtC,8BAA8B;GAC9B,gCAAgC;GAChC,wCAAwC;GACxC,kEAAkE;GAClE,+BAA+B;GAC/B,mDAAmD;;GAEnD,iCAAiC;GACjC,qCAAqC;GACrC,4BAA4B;GAC5B,oCAAoC;GACpC,8BAA8B;GAC9B,0CAA0C;;GAE1C,8BAA8B;GAC9B,8BAA8B;GAC9B,kCAAkC;GAClC,6BAA6B;GAC7B,4BAA4B;AAC/B;;;;AAIA,kCAAkC;AAClC;GACG,sBAAsB;GACtB,yCAAyC;;AAE5C;;AAEA,oCAAoC;AACpC;GACG,UAAU;GACV,WAAW;GACX,iCAAiC;AACpC;;AAEA;GACG,6BAA6B;GAC7B,mCAAmC;AACtC;;AAEA;GACG,2BAA2B;GAC3B,mBAAmB;AACtB;;AAEA;GACG,SAAS;AACZ;;AAEA;GACG,kCAAkC;GAClC,kBAAkB;AACrB;;AAEA;GACG,YAAY;GACZ,aAAa;GACb,aAAa;GACb,cAAc;GACd,uCAAuC;GACvC,iBAAiB;GACjB,gBAAgB;AACnB;;AAEA;GACG,sCAAsC;AACzC;;AAEA,gCAAgC;AAChC;;;;GAIG,yBAAyB;GACzB,cAAc;AACjB;;AAEA;GACG,yBAAyB;GACzB,WAAW;AACd;;AAEA;;;GAGG,kBAAkB;GAClB,iCAAiC;GACjC,qBAAqB;GACrB,aAAa;AAChB;;AAEA;;;;GAIG,qCAAqC;AACxC;;AAEA;GACG,kCAAkC;AACrC;;AAEA;;;;GAIG,2BAA2B;AAC9B;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,wBAAwB;GACxB,gBAAgB;GAChB,WAAW;GACX,mBAAmB;GACnB,YAAY;GACZ;4CACyC;AAC5C;;AAEA;GACG,iCAAiC;GACjC;AACH;;AAEA;GACG,mDAAmD,EAAE,kDAAkD;GACvG,oCAAoC;AACvC;;AAEA;GACG,oDAAoD,CAAC,kBAAkB;GACvE,oCAAoC;AACvC;;AAEA;GACG,wBAAwB;GACxB,kCAAkC;GAClC,qCAAqC;GACrC,WAAW;GACX,YAAY;GACZ,mBAAmB;GACnB,eAAe;AAClB;;AAEA;GACG,WAAW;GACX,mBAAmB;GACnB,YAAY;GACZ;4CACyC;AAC5C;;AAEA;GACG,kCAAkC;GAClC,qCAAqC;GACrC,WAAW;GACX,YAAY;GACZ,mBAAmB;GACnB,eAAe;AAClB;;AAEA;;;GAGG;;;;MAIG,YAAY;GACf;;GAEA;MACG,YAAY;GACf;;GAEA;MACG,wBAAwB;MACxB,gBAAgB;MAChB,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX;+CACyC;GAC5C;;GAEA;MACG,WAAW;MACX,YAAY;MACZ,mBAAmB;GACtB;;GAEA;MACG,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX;+CACyC;GAC5C;;GAEA;MACG,WAAW;MACX,YAAY;MACZ,mBAAmB;GACtB;AACH;;AAEA;;;GAGG,mCAAmC;AACtC;;AAEA;;;;GAIG,WAAW;GACX,uEAAuE;GACvE,mCAAmC;AACtC;;AAEA;;;GAGG,0BAA0B;AAC7B;;;AAGA,gCAAgC;AAChC;;;;;;GAMG;AACH;;AAEA,2BAA2B;AAC3B;GACG,iBAAiB;GACjB,0BAA0B;GAC1B;AACH;;AAEA;GACG,YAAY;GACZ,qBAAqB;GACrB,iCAAiC;GACjC,iCAAiC;GACjC,eAAe;GACf,kBAAkB;GAClB;6BAC0B;GAC1B,mBAAmB;GACnB,2BAA2B;GAC3B,0BAA0B;GAC1B,eAAe;GACf,qBAAqB;GACrB,eAAe;AAClB;;AAEA;GACG,+CAA+C;AAClD;;AAEA;GACG,uCAAuC;GACvC,YAAY;AACf;;AAEA;;;;;;;GAOG,WAAW;GACX,UAAU;AACb;;;AAGA;;GAEG;MACG,eAAe;GAClB;AACH;;AAEA;;GAEG,6BAA6B;GAC7B,aAAa;GACb,mBAAmB;GACnB,uBAAuB;AAC1B;;AAEA;GACG,uBAAuB;AAC1B;;;AAGA;GACG,kCAAkC;GAClC,kCAAkC;GAClC,kBAAkB;AACrB;;AAEA;GACG,sCAAsC;AACzC;;AAEA,SAAS;AACT;GACG,uBAAuB;GACvB,eAAe;GACf,qBAAqB;GACrB,0BAA0B;AAC7B;;AAEA;GACG,0BAA0B;GAC1B,+BAA+B;AAClC;;AAEA;GACG,mDAAmD;GACnD,aAAa;AAChB;;AAEA,UAAU;AACV;GACG,0BAA0B;AAC7B;;AAEA;GACG,4BAA4B;AAC/B;;AAEA,kFAAkF;AAClF;GACG,oBAAoB;GACpB,2BAA2B;AAC9B;;AAEA,+DAA+D;AAC/D;GACG,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,0BAA0B;AAC7B;;AAEA,+FAA+F;AAC/F;GACG,YAAY;GACZ,qBAAqB;GACrB,iCAAiC;GACjC,iCAAiC;GACjC,eAAe;GACf,gBAAgB;GAChB,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;GACnB,2BAA2B;GAC3B,0BAA0B;GAC1B,mCAAmC;GACnC,+BAA+B;GAC/B,aAAa;AAChB;;AAEA;GACG,+CAA+C;AAClD;;AAEA,YAAY;AACZ;;;;;;GAMG,SAAS;GACT,uBAAuB;AAC1B;;AAEA;GACG,cAAc;AACjB;;AAEA,WAAW;AACX;GACG;;;;;KAKE;GACF,sBAAsB;AACzB;;AAEA,eAAe;AACf;GACG,SAAS;GACT,uBAAuB;AAC1B;;AAEA,UAAU;AACV;;GAEG,WAAW;GACX,gBAAgB;AACnB;;AAEA,kDAAkD;AAClD;GACG,YAAY;GACZ,iBAAiB;GACjB,iBAAiB;GACjB,eAAe;AAClB;;AAEA,SAAS;AACT;GACG,eAAe;AAClB;;AAEA;GACG,yCAAyC;AAC5C;;AAEA;GACG,eAAe;GACf,yCAAyC;AAC5C;;AAEA;GACG,0DAA0D;AAC7D;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,kBAAkB;GAClB,WAAW;GACX,iCAAiC;AACpC;;AAEA;GACG,mCAAmC;GACnC,uBAAuB;GACvB,sBAAsB;GACtB,aAAa;AAChB;;AAEA;GACG,qBAAqB;GACrB,uBAAuB;GACvB,gCAAgC;GAChC,cAAc;AACjB;;AAEA;GACG,sBAAsB;AACzB;;AAEA,kBAAkB;AAClB;GACG,yBAAyB;GACzB,iGAAiG;GACjG,mBAAmB;GACnB,oEAAoE;GACpE,WAAW;GACX,kBAAkB;GAClB,kCAAkC;AACrC;;AAEA;GACG,sCAAsC;AACzC;;AAEA;GACG,oCAAoC;AACvC;;AAEA,wBAAwB;AACxB;GACG,gBAAgB;GAChB,MAAM;GACN,4BAA4B;GAC5B,UAAU;AACb;;AAEA;GACG,iBAAiB;GACjB,sCAAsC;GACtC,0BAA0B;GAC1B,mBAAmB;GACnB,uBAAuB;GACvB,gBAAgB;GAChB,gBAAgB;AACnB;;AAEA,qBAAqB;AACrB;GACG,mBAAmB;GACnB,uBAAuB;GACvB,gBAAgB;GAChB,0BAA0B;AAC7B;;AAEA;GACG;AACH","sourcesContent":["@font-face {\r\n   font-family: 'NotoSans-Regular';\r\n   src:\r\n      url(\"../static/fonts/NotoSans/woff2/NotoSans-Regular.woff2\") format('woff2'),\r\n      url(\"../static/fonts/NotoSans/woff/NotoSans-Regular.woff\") format('woff'),\r\n      url(\"../static/fonts/NotoSans/ttf/NotoSans-Regular.ttf\") format('truetype');\r\n   font-weight: normal;\r\n   font-style: normal;\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'NotoSans-Bold';\r\n   src: url(\"../static/fonts/NotoSans/woff2/NotoSans-Bold.woff2\") format('woff2'),\r\n      url(\"../static/fonts/NotoSans/woff/NotoSans-Bold.woff\") format('woff'),\r\n      url(\"../static/fonts/NotoSans/ttf/NotoSans-Bold.ttf\") format('truetype');\r\n   font-weight: normal;\r\n   font-style: normal;\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'NotoSans-SemiBold';\r\n   src: url(\"../static/fonts/NotoSans/woff2/NotoSans-SemiBold.woff2\") format('woff2'),\r\n      url(\"../static/fonts/NotoSans/woff/NotoSans-SemiBold.woff\") format('woff'),\r\n      url(\"../static/fonts/NotoSans/ttf/NotoSans-SemiBold.ttf\") format('truetype');\r\n   font-weight: normal;\r\n   font-style: normal;\r\n   font-display: swap;\r\n}\r\n\r\n:root {\r\n   --font-main: 'NotoSans-Regular';\r\n   --font-bold: 'NotoSans-Bold';\r\n   --font-semi-bold: 'NotoSans-SemiBold';\r\n\r\n   /* These colors brought to you by the mysterious Janette? It appears on the\r\n    desktop style sheet. Legend has it that at some point, a graphic designer was hired to \r\n    create mockups for the web and potentially the desktop. \r\n    There is tension about this decision so no one knows \r\n    if we should indeed be using the mockups as a reference. \r\n    But, according to Sean, these colors were approved by PM or someone decided they \r\n    \"made things look nice.\" \r\n    https://discordapp.com/channels/400029880110022666/775428762803503124/1033103249588371546\r\n    Marketing does not know about these colors as of 10/2022.*/\r\n\r\n   --darkest: #050505;\r\n   --dark-mine-shaft: #191919;\r\n   --less-dark-mine-shaft: #1d1d1d;\r\n     /* from marketing 10/17/22, numbers 20-80 refer to percentage of tint\r\n        These colors do not completely match desktop and I'm not sure why. It's not just the RGB\r\n        values being different from HEX codes. For example, there are 4 orange hues on\r\n        desktop and none of them match the RGB value for Orange Blaze from marketing.\r\n    */\r\n   --true-white: white;\r\n\r\n   --mine-shaft: #222222;\r\n   --mine-shaft-90: #333333;\r\n   --mine-shaft-80: #4F4C4D;\r\n   --mine-shaft-60: #717171;\r\n   --mine-shaft-40: #9E9E9E;\r\n   --mine-shaft-20: #CDCDCD;\r\n\r\n   --dust-gray: #898C8E;\r\n   --dust-gray-80: #ABAEAF;\r\n   --dust-gray-60: #B6B8B9;\r\n   --dust-gray-40: #CECFD0;\r\n   --dust-gray-20: #E6E6E6;\r\n\r\n   --alto-gray: #C4C4C4;\r\n   --alto-gray-80: #E0DFDE;\r\n   --alto-gray-60: #E7E7E6;\r\n   --alto-gray-40: #EFEFEE;\r\n   --alto-gray-20: #F9F9F9;\r\n\r\n   --blue-stone: #005D63;\r\n   --blue-stone-80: #037C7F;\r\n   --blue-stone-60: #5A9C9D;\r\n   --blue-stone-40: #92BCBD;\r\n   --blue-stone-20: #C8DDDD;\r\n\r\n   --deep-teal: #008996;\r\n   --deep-teal-80: #00A1AA;\r\n   --deep-teal-60: #3DB9BE;\r\n   --deep-teal-40: #8AD0D3;\r\n   --deep-teal-20: #C6E7E8;\r\n\r\n   --jade-glow: #00C08B;\r\n   --jade-glow-80: #00CEA1;\r\n   --jade-glow-60: #6ADBB8;\r\n   --jade-glow-40: #A1E8CF;\r\n   --jade-glow-20: #DBF2EC;\r\n\r\n   --supernova-gold: #FFD100;\r\n   --supernova-gold-80: #FFD934;\r\n   --supernova-gold-60: #FFE270;\r\n   --supernova-gold-40: #FFEBA1;\r\n   --supernova-gold-20: #FFF4D0;\r\n\r\n   --orange-blaze: #FF6B00;\r\n   --orange-blaze-80: #FF8C1C;\r\n   --orange-blaze-60: #FFA95D;\r\n   --orange-blaze-40: #FFC692;\r\n   --orange-blaze-20: #FFE2C7;\r\n\r\n   --red-fire: #E04403;\r\n   --red-fire-80: #EE6E3D;\r\n   --red-fire-60: #F8946B;\r\n   --red-fire-40: #FFB79A;\r\n   --red-fire-20: #FFDBCB;\r\n\r\n   /*Colors for code editor*/\r\n   --light-green: #008f00;\r\n   --dark-green: #008f00;\r\n\r\n   /* Global Semantic Coloring */\r\n   --widget-disabled-opacity: 40%;\r\n   --transparent: transparent;\r\n   --success: var(--jade-glow);\r\n   --warning: var(--supernova-gold);\r\n   --error: var(--red-fire);\r\n   --required: var(--red-fire);\r\n\r\n   /* Global Semantic Padding & Margins */\r\n   --padding: 10px;\r\n   --padding-lg: calc(var(--padding) * 2);\r\n   --padding-sm: calc(var(--padding) / 2);\r\n   --margin: 5px;\r\n\r\n   /* Global Semantic Border Radius */\r\n   --border-radius: 10px;\r\n\r\n   /* Global Semantic Fontsize */\r\n   --font-size: 16px;\r\n\r\n   /* Global Height */\r\n   --input-height: 40px;\r\n\r\n   /* Global Width */\r\n   --input-width: 300px;\r\n\r\n   /* Header Menu Vars (Theme-less, might change) */\r\n   --header-bg: var(--mine-shaft-80);\r\n   --header-drop-down-bg: var(--mine-shaft-40);\r\n   --header-drop-down-hover: var(--darkest);\r\n\r\n   --fa-width: auto\r\n}\r\n\r\n/* Semantic theme Variables */\r\n[data-theme=\"Light\"] {\r\n   --text: var(--mine-shaft);\r\n   /* According to Bri this is only used for text in disabled text boxes, not buttons or links etc - those will be set to --widget-disabled-opacity */\r\n   --text-disabled: var(--dust-gray);\r\n   --window-bg: var(--alto-gray-40);\r\n   /* if we do want to differentiate a child window from the parent we use the ecl::SubWindowBg - Brianna */\r\n   --sub-window-bg: var(--true-white);\r\n   /* popupBG is for popups, which is everything that isnt a normal window, this includes modals, tooltips, context menus - Brianna */\r\n   --popup-bg: var(--true-white);\r\n\r\n   /* frameBg is the background color of widgets, like the inside of the square of a tex box - Brianna */\r\n   --frame-bg: var(--true-white);\r\n   --frame-bg-hovered: var(--alto-gray);\r\n   --border: 1px solid var(--alto-gray-80);\r\n\r\n   /* Buttons */\r\n   --button-primary: var(--mine-shaft-60);\r\n   --button-primary-hovered: var(--mine-shaft-40);\r\n   --button-primary-text: var(--true-white);\r\n   --button-primary-clicked: var(--deep-teal-20);\r\n\r\n   /* Tabs */\r\n   /* these are for things like tabs on documents and links in the nav bar \r\n    maybe drop down options that you'd hover and select? Didn't want to call it 'option' bc of HTML option\r\n    */\r\n   --tab-unfocused-active: var(--dust-gray-40);\r\n   --tab-hovered: var(--jade-glow-20);\r\n\r\n   --required-text-color: var(--red-fire);\r\n\r\n   /* Extra web semantic colors */\r\n   --link-text: var(--deep-teal);\r\n   --link-text-hovered: var(--deep-teal-80);\r\n   /* Needed a different color scheme for the right-side info panel */\r\n   --sidebar-bg: var(--true-white);\r\n   --outline-focus-visible: 1px solid var(--jade-glow);\r\n   /*Table Theming, alternate rows */\r\n   --table-alt-row: var(--sub-window-bg);\r\n   --table-body-border: var(--dust-gray-20);\r\n   --table-row-hover: var(--blue-stone-20);\r\n\r\n   /*I needed another gray color*/\r\n   --gray-accent: var(--dust-gray-20);\r\n\r\n   /*Need colors for code editor*/\r\n   --t-comment: var(--light-green);\r\n   --t-variable-name: #ef5312;\r\n   --t-keyword: #00b785;\r\n   --t-function: #d5af00;\r\n}\r\n\r\n[data-theme=\"Dark\"] {\r\n   --text: var(--true-white);\r\n   /* According to Bri this is only used for text in disabled text boxes, not buttons or links etc - those will be set to --widget-disabled-opacity */\r\n   --text-disabled: var(--dust-gray);\r\n   --window-bg: var(--mine-shaft);\r\n   /* if we do want to differentiate a child window from the parent we use the ecl::SubWindowBg - Brianna */\r\n   --sub-window-bg: var(--dark-mine-shaft);\r\n   /* popupBG is for popups, which is everything that isnt a normal window, this includes modals, tooltips, context menus - Brianna */\r\n   --popup-bg: var(--darkest);\r\n   /* frameBg is the background color of widgets, like the inside of the square of a tex box - Brianna */\r\n   --frame-bg: var(--mine-shaft);\r\n   --frame-bg-hovered: var(--mine-shaft-80);\r\n   --border: 1px solid var(--dust-gray);\r\n\r\n   /* Buttons */\r\n   --button-primary: var(--mine-shaft-60);\r\n   --button-primary-hovered: var(--mine-shaft-80);\r\n   --button-primary-text: var(--true-white);\r\n   --button-primary-clicked: var(--deep-teal-80);\r\n\r\n   /* Tabs */\r\n   /* these are for things like tabs on documents and links in the nav bar \r\n    maybe drop down options that you'd hover and select? Didn't want to call it 'option' bc of HTML option\r\n    */\r\n   --tab-unfocused-active: var(--dust-gray-80);\r\n   --tab-hovered: var(--jade-glow-80);\r\n\r\n   --required-text-color: var(--red-fire);\r\n\r\n   /* Extra web semantic colors */\r\n   --link-text: var(--deep-teal-60);\r\n   --link-text-hovered: var(--deep-teal-40);\r\n   /* Needed a different color scheme for the right-side info panel */\r\n   --sidebar-bg: var(--mine-shaft);\r\n   --outline-focus-visible: 1px solid var(--jade-glow);\r\n\r\n   /*Table Theming, alternate rows */\r\n   --table-alt-row: var(--sub-window-bg);\r\n   --table-body-border: #171717;\r\n   --table-row-hover: var(--blue-stone);\r\n   /*I needed another gray color*/\r\n   --gray-accent: var(--less-dark-mine-shaft);\r\n\r\n   /*Need colors for code editor*/\r\n   --t-comment: var(--dark-green);\r\n   --t-variable-name: var(--red-fire);\r\n   --t-keyword: var(--jade-glow);\r\n   --t-function: var(--warning);\r\n}\r\n\r\n\r\n\r\n/* Global default element styles */\r\n* {\r\n   box-sizing: border-box;\r\n   font-family: var(--font-main), sans-serif;\r\n\r\n}\r\n\r\n/* Chrome/safari scrollbar styling */\r\n*::-webkit-scrollbar {\r\n   width: 5px;\r\n   height: 5px;\r\n   background-color: var(--frame-bg);\r\n}\r\n\r\n*::-webkit-scrollbar-thumb {\r\n   background-color: var(--text);\r\n   border-radius: var(--border-radius);\r\n}\r\n\r\nhtml {\r\n   font-size: var(--font-size);\r\n   letter-spacing: 1px;\r\n}\r\n\r\nbody {\r\n   margin: 0;\r\n}\r\n\r\n#thematic-div {\r\n   background-color: var(--window-bg);\r\n   color: var(--text);\r\n}\r\n\r\n.universal-height-width-container {\r\n   width: 100vw;\r\n   width: 100dvw;\r\n   height: 100vh;\r\n   height: 100dvh;\r\n   /* these numbers need to come from PM */\r\n   min-height: 320px;\r\n   min-width: 320px;\r\n}\r\n\r\nnav {\r\n   background-color: var(--sub-window-bg);\r\n}\r\n\r\n/* Many birds, one stone rules */\r\ndiv,\r\nheader,\r\nmain,\r\n.main-router-main {\r\n   background-color: inherit;\r\n   color: inherit;\r\n}\r\n\r\n.main-router-main {\r\n   height: calc(100% - 60px);\r\n   width: 100%;\r\n}\r\n\r\ninput,\r\ntextarea,\r\nselect {\r\n   color: var(--text);\r\n   background-color: var(--frame-bg);\r\n   border: var(--border);\r\n   font: inherit;\r\n}\r\n\r\ninput:focus-visible,\r\ntextarea:focus-visible,\r\nselect:focus-visible,\r\nbutton:focus-visible {\r\n   outline: var(--outline-focus-visible);\r\n}\r\n\r\ninput:invalid:not(:placeholder-shown):not([type=\"checkbox\"]):not([type=\"radio\"]) {\r\n   outline: 2px solid var(--required);\r\n}\r\n\r\ninput,\r\nselect,\r\n.global-menu-select,\r\nbutton {\r\n   height: var(--input-height);\r\n}\r\n\r\ninput[type=\"file\"] {\r\n   padding: 7px;\r\n}\r\n\r\ninput[type='range'] {\r\n   -webkit-appearance: none;\r\n   appearance: none;\r\n   width: 100%;\r\n   border-radius: 13px;\r\n   height: 12px;\r\n   /* border: 1px solid var(--jade-glow-40);\r\n   background-color: var(--jade-glow-20);  */\r\n}\r\n\r\ninput:autofill {\r\n   background-color: var(--frame-bg);\r\n   color: var(--text)\r\n}\r\n\r\ninput:-webkit-autofill {\r\n   -webkit-box-shadow:0 0 0 50px var(--frame-bg) inset; /* Change the color to your own background color */\r\n   -webkit-text-fill-color: var(--text);\r\n}\r\n\r\ninput:-webkit-autofill:focus {\r\n   -webkit-box-shadow: 0 0 0 50px var(--frame-bg) inset;/*your box-shadow*/\r\n   -webkit-text-fill-color: var(--text);\r\n} \r\n\r\ninput[type='range']::-webkit-slider-thumb {\r\n   -webkit-appearance: none;\r\n   background-color: var(--jade-glow);\r\n   border: 1px solid var(--jade-glow-80);\r\n   width: 32px;\r\n   height: 32px;\r\n   border-radius: 16px;\r\n   cursor: pointer;\r\n}\r\n\r\ninput[type='range']::-moz-range-track {\r\n   width: 100%;\r\n   border-radius: 13px;\r\n   height: 12px;\r\n   /* border: 1px solid var(--jade-glow-40);\r\n   background-color: var(--jade-glow-20);  */\r\n}\r\n\r\ninput[type='range']::-moz-range-thumb {\r\n   background-color: var(--jade-glow);\r\n   border: 1px solid var(--jade-glow-60);\r\n   width: 32px;\r\n   height: 32px;\r\n   border-radius: 16px;\r\n   cursor: pointer;\r\n}\r\n\r\n@media (min-width: 769px) and (orientation: portrait),\r\n(min-height: 769px) and (orientation: landscape) {\r\n\r\n   input,\r\n   select,\r\n   .global-menu-select,\r\n   button {\r\n      height: 32px;\r\n   }\r\n\r\n   input[type=\"file\"] {\r\n      padding: 3px;\r\n   }\r\n\r\n   input[type='range'] {\r\n      -webkit-appearance: none;\r\n      appearance: none;\r\n      width: 100%;\r\n      border-radius: 8px;\r\n      height: 7px;\r\n      /* border: 1px solid var(--jade-glow-40);\r\n      background-color: var(--jade-glow-20);  */\r\n   }\r\n\r\n   input[type='range']::-webkit-slider-thumb {\r\n      width: 20px;\r\n      height: 20px;\r\n      border-radius: 10px;\r\n   }\r\n\r\n   input[type='range']::-moz-range-track {\r\n      width: 100%;\r\n      border-radius: 8px;\r\n      height: 7px;\r\n      /* border: 1px solid var(--jade-glow-40);\r\n      background-color: var(--jade-glow-20);  */\r\n   }\r\n\r\n   input[type='range']::-moz-range-thumb {\r\n      width: 20px;\r\n      height: 20px;\r\n      border-radius: 10px;\r\n   }\r\n}\r\n\r\ninput,\r\nselect,\r\nbutton {\r\n   border-radius: var(--border-radius);\r\n}\r\n\r\ninput,\r\ntextarea,\r\n.global-menu-select,\r\nselect {\r\n   width: 100%;\r\n   /* This min-width was causing the inputs inside of login in to blow up*/\r\n   /* min-width: var(--input-width); */\r\n}\r\n\r\ninput,\r\ntextarea,\r\nselect {\r\n   padding: var(--padding-sm);\r\n}\r\n\r\n\r\n/* Things that can be disabled */\r\nfieldset:disabled,\r\ninput:disabled,\r\noptgroup:disabled,\r\noption:disabled,\r\nselect:disabled,\r\ntextarea:disabled {\r\n   color: var(--text-disabled)\r\n}\r\n\r\n/* Element-specific rules */\r\nlabel {\r\n   font-weight: bold;\r\n   padding: var(--padding-sm);\r\n   display: block\r\n}\r\n\r\nbutton {\r\n   border: none;\r\n   text-decoration: none;\r\n   background: var(--button-primary);\r\n   color: var(--button-primary-text);\r\n   cursor: pointer;\r\n   text-align: center;\r\n   /* overflow: hidden;\r\n   text-overflow: ellipsis; */\r\n   white-space: nowrap;\r\n   transition: background 0.2s;\r\n   padding: var(--padding-sm);\r\n   font-size: 1rem;\r\n   margin: var(--margin);\r\n   min-width: 40px;\r\n}\r\n\r\nbutton:hover:not(:disabled) {\r\n   background-color: var(--button-primary-hovered);\r\n}\r\n\r\nbutton:disabled {\r\n   opacity: var(--widget-disabled-opacity);\r\n   cursor: auto;\r\n}\r\n\r\nbutton>img,\r\nsummary>img,\r\nimput>img,\r\ninput>.themed-svg-container,\r\nbutton>.themed-svg-container,\r\nsummary>.themed-svg-container,\r\n.select-custom-trigger>.themed-svg-container {\r\n   height: 1em;\r\n   width: 1em;\r\n}\r\n\r\n\r\n@media (min-width: 769px) and (orientation: portrait),\r\n(min-height: 769px) and (orientation: landscape) {\r\n   button {\r\n      min-width: 32px;\r\n   }\r\n}\r\n\r\nbutton:has(img),\r\nbutton:has(.themed-svg-container:only-child) {\r\n   background-color: transparent;\r\n   display: flex;\r\n   align-items: center;\r\n   justify-content: center;\r\n}\r\n\r\nbutton>p {\r\n   padding: var(--padding);\r\n}\r\n\r\n\r\nbutton.secondary-button {\r\n   background-color: var(--window-bg);\r\n   border: 1px solid var(--deep-teal);\r\n   color: var(--text);\r\n}\r\n\r\nbutton.secondary-button:hover {\r\n   background-color: var(--sub-window-bg);\r\n}\r\n\r\n/* Link */\r\na {\r\n   color: var(--link-text);\r\n   cursor: pointer;\r\n   text-decoration: none;\r\n   padding: var(--padding-sm);\r\n}\r\n\r\na:hover {\r\n   text-decoration: underline;\r\n   color: var(--link-text-hovered);\r\n}\r\n\r\np a {\r\n   /* No link padding when inside a paragraph element*/\r\n   padding: none;\r\n}\r\n\r\n/* Lists */\r\nol {\r\n   padding: var(--padding-lg);\r\n}\r\n\r\nul {\r\n   padding-left: var(--padding);\r\n}\r\n\r\n/* line-height is a more consistant spacer than using padding/margin on li items */\r\nli {\r\n   line-height: 1.75rem;\r\n   list-style-position: inside;\r\n}\r\n\r\n/* details and summary are related to list elements style wise*/\r\ndetails {\r\n   display: flex;\r\n   flex-direction: column;\r\n}\r\n\r\ndetails>details {\r\n   margin-left: var(--margin);\r\n}\r\n\r\n/* That said this is basically button without flex styling (due to historic list css reasons) */\r\nsummary {\r\n   border: none;\r\n   text-decoration: none;\r\n   background: var(--button-primary);\r\n   color: var(--button-primary-text);\r\n   cursor: pointer;\r\n   text-align: left;\r\n   overflow: hidden;\r\n   text-overflow: ellipsis;\r\n   white-space: nowrap;\r\n   transition: background 0.2s;\r\n   padding: var(--padding-sm);\r\n   border-radius: var(--border-radius);\r\n   margin: calc(var(--margin) / 2);\r\n   height: unset;\r\n}\r\n\r\nsummary:hover {\r\n   background-color: var(--button-primary-hovered);\r\n}\r\n\r\n/* Headers */\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n   margin: 0;\r\n   padding: var(--padding);\r\n}\r\n\r\nh1 {\r\n   font-size: 2em;\r\n}\r\n\r\n/* images */\r\nimg {\r\n   /*\r\n    This removes extra spacing below image margin due to img's inherent inline block display.\r\n    Essentially, images are treated like text and use text alignment properties, which pads outside the margin\r\n    a number of pixels based on the element's font size.  This is so that lowercase letters like 'g' and 'y' don't\r\n    hang below an element, even when its padding and margins are set to 0.\r\n    */\r\n   vertical-align: bottom;\r\n}\r\n\r\n/* paragraphs */\r\np {\r\n   margin: 0;\r\n   padding: var(--padding);\r\n}\r\n\r\n/* Input */\r\ninput[type=\"radio\"],\r\ninput[type=\"checkbox\"] {\r\n   width: 10px;\r\n   min-width: unset;\r\n}\r\n\r\n/*Make number pickers slightly bigger on chromium*/\r\ninput[type=\"number\"]::-webkit-inner-spin-button {\r\n   height: 10px;\r\n   padding: 10px 0px;\r\n   margin-right: 2px;\r\n   cursor: pointer;\r\n}\r\n\r\n/*Select*/\r\nselect {\r\n   cursor: pointer;\r\n}\r\n\r\nselect:hover {\r\n   background-color: var(--frame-bg-hovered);\r\n}\r\n\r\ninput:hover {\r\n   cursor: pointer;\r\n   background-color: var(--frame-bg-hovered);\r\n}\r\n\r\nbutton:active {\r\n   background-color: var(--button-primary-clicked) !important;\r\n}\r\n\r\nselect:focus {\r\n   outline: none;\r\n}\r\n\r\nselect::-ms-expand {\r\n   display: none;\r\n}\r\n\r\noption {\r\n   color: var(--text);\r\n   width: 20em;\r\n   background-color: var(--popup-bg);\r\n}\r\n\r\ntextarea {\r\n   border-radius: var(--border-radius);\r\n   padding: var(--padding);\r\n   vertical-align: bottom;\r\n   margin: unset;\r\n}\r\n\r\npre {\r\n   border: var(--border);\r\n   padding: var(--padding);\r\n   background: var(--sub-window-bg);\r\n   overflow: auto;\r\n}\r\n\r\ncode {\r\n   font-family: monospace;\r\n}\r\n\r\n/* Table Styling */\r\ntable {\r\n   border-collapse: collapse;\r\n   /* This supposedly lets the table render faster - like the top rows first -- needs more research*/\r\n   table-layout: fixed;\r\n   /* required for resizing, so size using parent container if needed */\r\n   width: 100%;\r\n   position: relative;\r\n   background-color: var(--window-bg);\r\n}\r\n\r\ntr:nth-child(odd) {\r\n   background-color: var(--table-alt-row);\r\n}\r\n\r\ntr:hover {\r\n   background-color: var(--tab-hovered);\r\n}\r\n\r\n/* table heading stuff */\r\nthead tr {\r\n   position: sticky;\r\n   top: 0;\r\n   border-bottom: var(--border);\r\n   z-index: 3;\r\n}\r\n\r\nth {\r\n   font-size: 1.2rem;\r\n   background-color: var(--sub-window-bg);\r\n   padding: var(--padding-sm);\r\n   white-space: nowrap;\r\n   text-overflow: ellipsis;\r\n   overflow: hidden;\r\n   text-align: left;\r\n}\r\n\r\n/* table item stuff */\r\ntd {\r\n   white-space: nowrap;\r\n   text-overflow: ellipsis;\r\n   overflow: hidden;\r\n   padding: var(--padding-sm);\r\n}\r\n\r\n.required-input {\r\n   color: var(--required-text-color)\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
